// This module is our wrapper around breeze, so we don't use the global

/*
* Shim breeze to use ES6 Promises.
*/
import './es6-shim/breeze-es6-shim';

import * as breeze_lib from 'breeze-client';
export const breeze = breeze_lib;
